import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { FormattedMessage } from 'react-intl';

const DragnDrop = (props) => {
  const [isUploadDragged, setIsUploadDragged] = useState(false);

  const { allowedMaxFileSize = Infinity, allowedMaxFileCount = Infinity } =
    props.fileUploadLimitations;

  const allowedFileExtensions = props.fileUploadLimitations.allowedFileExtensions.map((name) =>
    name.toLowerCase()
  );
  let fileCount = 0;

  const validatorWithLocale = (file) => {
    const filePath = file.path
    const fileExtension = filePath.substr(filePath.lastIndexOf(".") + 1).toLowerCase();
    if (
      allowedFileExtensions &&
      !allowedFileExtensions.includes('all') &&
      !allowedFileExtensions.includes(fileExtension)
    ) {
      return {
        code: 'extension-restriction',
        message: (
          <FormattedMessage
            id={`form.upload.restriction.extension`}
            values={{ extensionList: `${allowedFileExtensions.join(', ')}` }}
          />
        ),
      };
    }
    if (file.size > allowedMaxFileSize) {
      return {
        code: 'max-file-size-restriction',
        message: (
          <FormattedMessage
            id={`form.upload.restriction.size`}
            values={{ maxSize: allowedMaxFileSize }}
          />
        ),
      };
    }
    fileCount++;
    if (fileCount > allowedMaxFileCount) {
      return {
        code: 'max-file-count-restriction',
        message: (
          <FormattedMessage
            id={`form.upload.restriction.count`}
            values={{ maxCount: allowedMaxFileCount }}
          />
        ),
      };
    }
    return null;
  };

  const {
    fileRejections,
    acceptedFiles,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    validator: validatorWithLocale,
    onDrop: (acceptedFiles) => {
      setIsUploadDragged(true);
      props.onAcceptedFileDrag(acceptedFiles);
    },
  });

  const className = useMemo(
    () =>
      classNames('custom-dropzone', {
        dragging: isDragActive,
        accepted: isDragAccept,
        rejected: isDragReject,
      }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const acceptedFileItems = acceptedFiles.map((file) => <li key={file.path}>{file.path}</li>);

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} {<FormattedMessage id="form.upload.bytes" />}
      <ul>
        {errors.map((e) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));

  return (
    <>
      <label className="form-label" htmlFor="online-registration-file-upload-container">
      <FormattedMessage id={'form.upload.dragAndDropTitle'} />
      </label>
      <section id="online-registration-file-upload-container">
        <div {...getRootProps({ className })}>
          <input {...getInputProps()} />
          <p>
            <FormattedMessage id={'form.upload.dragAndDropMessage'} />
          </p>
        </div>
        {isUploadDragged && (
          <aside>
            <div className="form-label">
              <FormattedMessage id={'form.upload.acceptedFiles'} />
            </div>
            <ul>{acceptedFileItems}</ul>
            <div className="form-label">
              <FormattedMessage id={'form.upload.rejectedFiles'} />
            </div>
            <ul>{fileRejectionItems}</ul>
          </aside>
        )}
      </section>
    </>
  );
};

DragnDrop.defaultProps = {
  fileUploadLimitations: {},
};

export default DragnDrop;
